/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Request_RejectedInputs */



/**
* | output |
* | --- |
* | "The request could not be sent. Please try again." |
*
* @param {Chat_Error_Request_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_request_rejected = /** @type {((inputs?: Chat_Error_Request_RejectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Request_RejectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("The request could not be sent. Please try again.")
});